import { Heading } from '@core/ui';
import { WebinarCardTitleProps } from './types';

export const WebinarCardTitle = ({ children }: WebinarCardTitleProps) => (
    <Heading variant="h1" classNames={`mb-4`}>
        {children}
    </Heading>
);
